"use client";

export default function TabbedList({
  filteredApplications,
  onApplicationClick,
}) {
  // Define status categories based on agent presence
  const statuses = ["Pending", "In-Progress"];

  const columns = statuses.map((status) => ({
    status,
    applications: filteredApplications
      .filter((app) => {
        // Determine status based on agent presence
        if (status === "Pending") {
          return !app.agent?.firstName;
        } else if (status === "In-Progress") {
          return app.agent?.firstName;
        }
        return false;
      })
      .map((app) => ({
        id: app._id,
        name: app.firstName + " " + app.lastName,
      })),
  }));

  return (
    <div className="flex gap-4 overflow-x-auto h-max text-nowrap">
      {columns.map((column, index) => (
        <div
          key={index}
          className="w-full bg-white rounded-lg shadow-sm border border-gray-400"
        >
          <div className="bg-[#005B96] text-white px-3 py-6 rounded-t-lg">
            <h2 className="font-medium">{column.status}</h2>
          </div>
          <div className="p-3">
            {column.applications.length > 0 ? (
              column.applications.map((app) => (
                <div
                  key={app.id}
                  className="py-4 border-b border-gray-400 last:border-0 cursor-pointer hover:underline"
                  onClick={() => onApplicationClick(app.id)}
                >
                  {app.name}
                </div>
              ))
            ) : (
              <div className="text-gray-500 italic">No applications</div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}